"use strict";

const TICKET_STORAGE_KEY = "bf-mcp-oauth-ticket";
const TICKET_TTL_MS = 10 * 60 * 1000;

function savePendingTicket(storage, ticket, now) {
    storage.setItem(TICKET_STORAGE_KEY, JSON.stringify({
        ticket: ticket,
        exp: now + TICKET_TTL_MS
    }));
}

function readPendingTicket(storage, now) {
    const raw = storage.getItem(TICKET_STORAGE_KEY);
    if (!raw) {
        return null;
    }

    try {
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.ticket || !parsed.exp || parsed.exp <= now) {
            storage.removeItem(TICKET_STORAGE_KEY);
            return null;
        }
        return parsed.ticket;
    } catch (error) {
        return null;
    }
}

function clearPendingTicket(storage) {
    storage.removeItem(TICKET_STORAGE_KEY);
}

async function callbackHostForTicket({ fetchFn, ticket }) {
    if (!ticket) {
        return "";
    }

    const response = await fetchFn("/mcp/oauth/authorize/request?ticket=" + encodeURIComponent(ticket));
    const body = await response.json().catch(() => ({}));
    if (!response.ok || typeof body.redirect_host !== "string") {
        return "";
    }
    return body.redirect_host;
}

function rememberTicketFromUrl(storage, ticket, now) {
    if (!ticket || readPendingTicket(storage, now) === ticket) {
        return;
    }
    savePendingTicket(storage, ticket, now);
}

async function approvePendingTicket({ storage, fetchFn, navigate, token, now }) {
    const ticket = readPendingTicket(storage, now);
    if (!ticket) {
        return { ok: false, reason: "no_request" };
    }

    const response = await fetchFn("/mcp/oauth/authorize/complete", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
        },
        body: JSON.stringify({ ticket: ticket })
    });
    const body = await response.json().catch(() => ({}));

    if (response.status === 401) {
        return { ok: false, reason: "login_expired" };
    }
    if (!response.ok || !body.redirect_uri) {
        return { ok: false, reason: body.error || "approval_failed" };
    }

    clearPendingTicket(storage);
    navigate(body.redirect_uri);
    return { ok: true };
}

module.exports = {
    savePendingTicket,
    readPendingTicket,
    clearPendingTicket,
    rememberTicketFromUrl,
    callbackHostForTicket,
    approvePendingTicket
};
